export default __webpack_public_path__ + "static/media/hht1_ep10_timeline_q05_a.072a1716.png";